/**
 * Return the calculated width of a DOMelement
 * @param {DOMelement} el - the element to sizeup
 * @return {Number} The width of an element
 */
var outerWidth = function outerWidth(el) {
  return parseFloat(getComputedStyle(el, null).width.replace('px', ''));
};

export default outerWidth;